<template lang="pug">
.package-contents.px-5
  v-row(align="center")
    v-col
      h2.primary--text {{ $tc('PackageContent._name', 2) }}
    v-spacer
    v-col(cols="auto")
      g-btn.primary--text.mr-5(@click.stop="dialog = true") {{ $t('PackageContent.addItem') }}
      modal-package-item(
        v-if="dialog",
        v-model="dialog",
        v-bind="{ path, entity, parentInstance }",
      )
      g-btn.primary--text.mr-5(@click.stop="dialogPackage = true") {{ $tc('PackageContent.packageQuantity', 1) }}
      modal-package-quantities(
        v-if="dialogPackage",
        v-model="dialogPackage",
        path="packageContents",
        :pathShipmentItems="path",
        pathPackages="packages",
        v-bind="{ entity, parentInstance, fromPackage }"
      )

  template(v-for="(pckg, i) in instance")
    template(v-if="isNotDeleted(pckg)")
      app-entity(
        :extra-data="extraData",
        :chips="false",
        :path="`${path}[${i}]`",
        :parentPath="`${path}`",
        :entity="$findEntity(relation.type)",
        fromList,
        :key="key+ '' + i",
        :elementIndex="i",
        :visibleIndex="findVisibleIndex(visibleItems, pckg, 'itemNo')",
        :packageContent="getRelatedPackageContent(parentInstance, pckg)",
        v-bind="{ ...$attrs, parent, selectorOnly, showInfo, relation, isActive, modalInstance }",
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")
      extra-field-groups(:path="`${path}[${i}]`", v-bind="{ entity }")
</template>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: ['entity', 'chips', 'invert', 'relation', 'path', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isDraft', 'isActive', 'fromPackage'],
  data: () => ({
    key: 0,
    dialog: false,
    dialogPackage: false,
  }),
  methods: {
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    findVisibleIndex(visibleItems, element, path) {
      if (!visibleItems) return null;
      return visibleItems.findIndex(vp => {
        return vp[path] === element[path];
      });
    },
    getRelatedPackageContent({ packageContents }, { itemNo }) {
        if (!itemNo || !packageContents) return null;
        let result = packageContents
            .filter(this.isNotDeleted)
            .filter(pC => pC.itemNo === itemNo)
            .map(pC => ({ ...pC, package: this.parentInstance, visibleIndex: this.findVisibleIndex(this.visiblePackages, _.get(pC, 'package', {}), 'packageNo') }));

        return result;
    },
  },
  computed: {
    visibleItems() {
      return (this.instance || []).filter(this.isNotDeleted);
    },
    visiblePackages() {
      return _.get(this.parentInstance, 'packages', []).filter(this.isNotDeleted);
    },
  },
}
</script>
